import React, { useEffect, useRef, useState } from "react";
import API from "../api/Api";
import { BASE_URL } from "../api/Api";

const TopPartners = () => {
  const sliderRef = useRef(null);
  const [partners, setPartners] = useState([]);
 useEffect(() => {
  API.get("/partners")
    .then((res) => {
      const data = res.data.data || [];

      setPartners(
        data.map((item) => ({
          name: item.name,
          logo: item.logo, 
          
        }))
      );
      console.log("Partners API Response:", data)
    })
    
    .catch((err) => {
      console.error("Partners API Error", err);
    });
}, []);

  // 🔹 Auto scroll (UNCHANGED)
  useEffect(() => {
    if (!sliderRef.current || partners.length === 0) return;

    const slider = sliderRef.current;
    let speed = 0.5;
    let animationId;

    const autoScroll = () => {
      slider.scrollLeft += speed;

      // Infinite loop
      if (slider.scrollLeft >= slider.scrollWidth / 2) {
        slider.scrollLeft = 0;
      }

      animationId = requestAnimationFrame(autoScroll);
    };

    animationId = requestAnimationFrame(autoScroll);

    const stop = () => cancelAnimationFrame(animationId);
    const start = () => (animationId = requestAnimationFrame(autoScroll));

    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);

    return () => {
      cancelAnimationFrame(animationId);
      slider.removeEventListener("mouseenter", stop);
      slider.removeEventListener("mouseleave", start);
    };
  }, [partners]);

  return (
    <>
      {/* PARTNERS SECTION */}
      <section className="ucsr-partners-section container-fluid">
        <div className="ucsr-partners-header">
          <h2>Top Contributing Partners</h2>
          {/* <a href="#">
            View All Partners <i className="fa-solid fa-arrow-right"></i>
          </a> */}
        </div>

       <div className="ucsr-partners-slider mb-5" ref={sliderRef}>
  {[...partners, ...partners].map((partner, index) => (
   <div className="ucsr-partner-card" key={index}>
  <img
    src={`${BASE_URL}/assets/images/${encodeURIComponent(partner.logo)}`}
    alt={partner.name}
    className="ucsr-partner-logo"
  />
  {/* <p>{partner.name}</p> */}
</div>
  ))}
</div>
      </section>

      {/* CTA SECTION */}
      {/* <section className="container pb-5">
        <div className="ucsr-partners-cta">
          <h3>Ready to Make a Difference?</h3>
          <p>
            Join 15,000+ organizations and individuals creating measurable
            social impact across India
          </p>

          <div className="ucsr-partners-actions">
            <a href="#" className="ucsr-btn-primary">
              Start Registration <i className="fa-solid fa-arrow-right"></i>
            </a>
            <a href="#" className="ucsr-btn-outline">
              Schedule a Demo
            </a>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default TopPartners;
